export enum ExportType {
  ccm = 'ccm',
  canvas = 'canvas',
  moodle = 'moodle',
  scorm = 'scorm',
  iracademy = 'iracademy',
}
